import { Link, useLocation } from "react-router-dom";

const LEGAL_LINKS = [
  { to: "/legal", label: "Mentions légales" },
  { to: "/cgu", label: "CGU" },
  { to: "/confidentialite", label: "Confidentialité" },
  { to: "/about", label: "À propos" },
];

export function AppFooter() {
  const { pathname } = useLocation();
  const isLegalPage = LEGAL_LINKS.some((l) => l.to === pathname);

  return (
    <footer className="py-4 border-t border-border/30 text-center space-y-2">
      <nav className="flex items-center justify-center gap-2 text-xs text-muted-foreground flex-wrap">
        {LEGAL_LINKS.map((link, i) => (
          <span key={link.to} className="flex items-center gap-2">
            {i > 0 && <span>·</span>}
            <Link to={link.to} className="hover:text-foreground transition-colors">
              {link.label}
            </Link>
          </span>
        ))}
      </nav>

      {isLegalPage && (
        <nav className="flex items-center justify-center gap-2 text-[11px] text-muted-foreground flex-wrap">
          <span className="font-medium">Pages légales :</span>
          {LEGAL_LINKS.map((link, i) => (
            <span key={link.to} className="flex items-center gap-2">
              {i > 0 && <span>·</span>}
              {link.to === pathname ? (
                <span className="text-primary font-medium">{link.label}</span>
              ) : (
                <Link to={link.to} className="hover:text-foreground transition-colors">
                  {link.label}
                </Link>
              )}
            </span>
          ))}
        </nav>
      )}
    </footer>
  );
}
